import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getFundMainClass } from '@finect/front-resources/Products';
import { feeTypes, periods, getProductTypeById } from './../../utils';
var productType = getProductTypeById('fund');
var handleClickOnProduct = function handleClickOnProduct(id) {
  window.location.href = "".concat(productType.slug, "/").concat(id);
};
var reducePerformancePeriod = function reducePerformancePeriod(stats, periodCode, type) {
  var match = stats.find(function (stat) {
    return stat.period === periodCode && stat.type === type;
  });
  return match ? match : null;
};
export { feeTypes, periods };
export var doSeries = function doSeries(funds, product, colors, xAxis, yAxis) {
  var fundsSerie = {
    name: productType.shortPlural,
    data: []
  };
  funds.forEach(function (fund) {
    var fundClass = getFundMainClass(fund);
    var performanceX = reducePerformancePeriod(fund.stats.performance.periods, xAxis, 'accumulated');
    var performanceY = reducePerformancePeriod(fund.stats.performance.periods, yAxis, 'accumulated');
    if (performanceX && performanceX.value && performanceY && performanceY.value) {
      fundsSerie.data.push({
        id: fundClass.id,
        name: fundClass.name,
        x: performanceX.value,
        y: performanceY.value,
        marker: {
          radius: product.id === fundClass.id ? 12 : 5,
          fillColor: product.id === fundClass.id ? colors.chart6 : colors.chart1,
          lineColor: product.id === fundClass.id ? colors.chart6 : colors.chart1
        },
        events: {
          click: function click(event) {
            handleClickOnProduct(event.point.id);
          }
        }
      });
    }
  });
  var series = [fundsSerie];
  return series;
};